import React, { Component } from 'react';
import { connect } from 'react-redux';

import routes from '../Constants/routes';
import helpers from '../Utils/helpers';

class Login extends Component {
    render() {
        if (this.props.isAuthenticating) {
            return null;
        }

        //let location = (this.props.location && this.props.location.pathname) || '/';
        let location = window.location.pathname;

        if (location.indexOf(routes.logout) > -1) {
            location = '/';
        }

        return (
            <div className="loginForm position-absolute-center">
                <div className="ml-96 mr-96 mt-24 border-bottom">
                    <h1 className="mb-16">Sign in</h1>
                </div>
                <div className="position-absolute-center">
                    <a href={`${helpers.getFullApiHostname()}/api/auth/login?returnPath=${location}`} className="btn btn-primary btn-lg m-0">
                        <span className="vismaicon vismaicon-google login-button-icon pt-6 rounded-circle" /> Sign in with Google
                    </a>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isAuthenticating: state.CommonReducer.authenticating,
    };
}

export default connect(mapStateToProps)(Login);
